export enum LoginType {
  GENERAL = 'general',
  SSO = 'sso',
  GENERAL_AND_SSO = 'general_and_sso'
}
